var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-success",attrs:{"type":"button"},on:{"click":_vm.onClick}},[_c('i',{staticClass:"fa fa-refresh"}),_vm._v(" Generate ")])
}
var staticRenderFns = []

export { render, staticRenderFns }